import 'whatwg-fetch' // Bundled with NWB
import { simple_api_request } from './simple_api_request' // Bundled with NWB
// TODO: Change API URL for production
const API_URL = 'https://api.funoro.com'

/**
 * GET request
 * @param {string} path
 * @param {string} [token]
 * @return {Promise<boolean>}
 */
export async function get (path, token) {
  try {
    const headers = new Headers()
    headers.append('Accept', 'application/json')
    if (typeof token !== 'undefined') {
      headers.append('Authorization', 'Bearer ' + token)
    }

    const result = await fetch(API_URL + path, {
      method: 'GET',
      headers,
      redirect: 'manual'
    })
    if (!result.ok) {
      return false
    }
    console.log('GET', API_URL + path, 'result', result)
    return await result.json()
  } catch (e) {
    console.error(e)
    return false
  }
}

/**
 * Async fetch wrapper
 * @param path
 * @param {Object} options
 * @return {Promise<*>}
 */
export async function fetch_wrapper (path, options) {
  console.log('fetch_wrapper - arguments', ...arguments)
  try {
    const response = await fetch(API_URL + path, options)
    console.log(options.method, API_URL + path, 'response', response)

    let result = {
      ok: response.ok,
      data: await response.json()
    }

    console.log(options.method, API_URL + path, 'result', result)
    return result
  } catch (e) {
    console.error(e)
    return false
  }
}

/**
 * Convert FormData to JSON stringified body
 * @param {Object} data FormData
 * @param {Object} [addedData]
 */
function json_body (data, addedData = {}) {
  // Convert FormData to JSON
  const dataObj = {...addedData}
  for (let [key, val] of data.entries()) {
    // console.log('post - data entry:', key, val)
    dataObj[key] = val
  }
  console.log('post - dataObj:', dataObj)
  return JSON.stringify(dataObj)
}

/**
 * API request with FormData entries
 * @param {string} path
 * @param {Object} data FormData entries
 * @param {Object} options
 * @param {string} [options.method] POST by default
 * @param {Object} [options.addedData]
 * @param {string} [options.token]
 * @param {string} [options.contentType] Content-Type header, by default: `application/json`
 * @param {boolean} [options.contentTypeDisabled] Disable Content-Type header, by default: undefined
 * @return {Promise<*>}
 */
export function api_request (path, data, options = {method: 'POST', addedData: {}}) {
  const APP_JSON = 'application/json'
  // Add headers for sending JSON
  const headers = new Headers()
  headers.append('Accept', APP_JSON)
  const contentType = typeof options.contentType === 'undefined'
    ? 'application/json'
    : options.contentType
  // We can disable the Content-Type header for fixing Matthias API
  // because it's not working with `multipart/form-data`
  if (typeof options.contentTypeDisabled === 'undefined'
    || !options.contentTypeDisabled) {
    headers.append('Content-Type', contentType)
  }
  if (typeof options.token !== 'undefined') {
    headers.append('Authorization', 'Bearer ' + options.token)
  }

  console.log('api_request_with_FormData - data:', data)
  return fetch_wrapper(path, {
    method: options.method,
    headers,
    body: contentType === APP_JSON
      ? json_body(data, options.addedData)
      : data,
    redirect: 'manual' // Fix: for 302 found response if user already created
  })
}

/**
 * POST request to API
 * @param {string} path
 * @param {Object} data FormData entries
 * @param {Object} options
 * @param {Object} [options.addedData]
 * @param {string} [options.token]
 * @param {string} [options.contentType] Content-Type header, by default: `application/json`
 * @return {Promise.<*>}
 */
export function post (path, data, options = {addedData: {}}) {
  options['method'] = 'POST'
  return api_request(path, data, options)
}

/**
 * DELETE request to API
 * @param {string} path
 * @param {Object} data FormData entries
 * @param {Object} options
 * @param {Object} [options.addedData]
 * @param {string} [options.token]
 * @param {string} [options.contentType] Content-Type header, by default: `application/json`
 * @return {Promise.<*>}
 */
export function api_delete (path, data, options = {addedData: {}}) {
  options['method'] = 'DELETE'
  return api_request(path, data, options)
}

export default {
  simple_api_request,
  fetch_wrapper,
  get,
  post,
  api_delete
}



// WEBPACK FOOTER //
// ./src/api/core.js